import React, { useContext } from 'react';
import { StringCatalog, StringsProviderProps } from './types';

const StringsContext = React.createContext<StringCatalog | undefined>(
  undefined,
);

export const StringsProvider: React.FC<StringsProviderProps> = ({
  children,
  strings,
}) => (
  <StringsContext.Provider value={strings}>{children}</StringsContext.Provider>
);

export function useStringsContext() {
  const context = useContext(StringsContext);

  if (context === undefined) {
    throw new Error('useStringsContext must be used within StringsProvider');
  }

  return context;
}
